import { useState } from "react";
import { CalendarIcon, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { iso, parse } from "@/components/project/ScheduleViews";

export default function DatePicker({ value, onChange, placeholder = "Pick a date", testid, min, className = "" }) {
  const [open, setOpen] = useState(false);
  const d = parse(value);
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" className={`h-10 w-full justify-start font-normal ${d ? "" : "text-muted-foreground"}`} data-testid={testid}>
            <CalendarIcon className="mr-2 h-4 w-4 shrink-0" />{d ? d.toLocaleDateString("en-CA", { weekday: "short", month: "short", day: "numeric", year: "numeric" }) : placeholder}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start" data-testid={testid ? `${testid}-popover` : undefined}>
          <Calendar mode="single" selected={d || undefined} defaultMonth={d || parse(min) || new Date()} disabled={min ? { before: parse(min) } : undefined} onSelect={(day) => { onChange(day ? iso(day) : ""); setOpen(false); }} initialFocus />
        </PopoverContent>
      </Popover>
      {d && <Button type="button" size="icon" variant="ghost" className="h-8 w-8 shrink-0" aria-label="Clear date" onClick={() => onChange("")} data-testid={testid ? `${testid}-clear` : undefined}><X className="h-3.5 w-3.5" /></Button>}
    </div>
  );
}
